import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Layouts
// import { FullLayoutComponent } from './layouts/full-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { RecruiterLayoutComponent } from './layouts/recruiter-layout.component';
import { P404Component } from './pages/404.component';
import { P403Component } from './pages/403.component';
import { AuthGuard } from './auth-guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'pages/login',
    pathMatch: 'full',
  },
  {
    path: 'pages', 
    component: SimpleLayoutComponent,   
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
      }
    ]
  },  
  {
    path: 'talent',
    canActivate: [AuthGuard],    
    // component: FullLayoutComponent,
    data: {
      title: 'Talent'
    },
    children: [
      {
        path: '',
        loadChildren: './talent/talent.module#TalentModule',
      },
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,  
    data: {
      title: 'Admin'
    },
    children: [
      {
        path: '',
        loadChildren: './admin/admin.module#AdminModule',
      },
    ]
  },
  {
    path: 'recruiter',  
    component: RecruiterLayoutComponent,
    data: {
      title: 'Recruiter'
    },
    children: [
      {
        path: '',
        loadChildren: './recruiter/recruiter.module#RecruiterModule',
      },
    ]
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  }, 
  {
    path: '403',
    component: P403Component,
    data: {
      title: 'Unauthorized Access'
    }
  },

  {path : '**',redirectTo: '404'}   
  
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts